import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter, Routes, Route, IndexRoute, useParams, useLocation } from "react-router-dom";
import TagManager from 'react-gtm-module';

import CircularProgress from '@mui/material/CircularProgress';

import Header from './Components/Layout/Header/Header.jsx';
import Footer from './Components/Layout/Footer/Footer.jsx';
import LeftLogo from './Components/Layout/LeftLogo';
import Start from './Pages/Start/Start.jsx';
import StartIndividual from './Pages/Start/StartIndividual.jsx';
import Assessment from './Pages/Assessment/Assessment.jsx';
import AssessmentV3 from './Pages/AssessmentV3/AssessmentV3.jsx';
import AssessmentAdditional from './Pages/AssessmentAdditional/AssessmentAdditional.jsx';
import Details from './Pages/Details/Details.jsx';
import Results from './Pages/Results/Results.jsx';
import Dashboard from './Pages/Dashboard/Dashboard.jsx';
import Invite from './Pages/Invite/Invite.jsx';
import InviteThankYou from './Pages/InviteThankYou/InviteThankYou.jsx';
import PreAssessment from './Pages/PreAssessment/PreAssessment.jsx';
import Walkthrough  from './Pages/Walkthrough/Walkthrough.jsx';
import PreAdditionalInfo from './Pages/PreAdditionalInfo/PreAdditionalInfo.jsx';
import PreAdditionalQuestions from './Pages/PreAdditionalQuestions/PreAdditionalQuestions.jsx';
// import PreAssessment from './Pages/PreAssessment';
// import { AssessmentProgressContextProvider } from './Store/AssessmentProgressContext';
// import AssessmentProgressSections from './Components/AssessmentProgressSections';

import { PreAdditionalQuestionContextProvider } from './Store/PreAdditionalQuestionContext';
import { AdditionalQuestionContextProvider } from './Store/AdditionalQuestionContext';
import { AssessmentQuestionContextProvider } from './Store/AssessmentQuestionContext';
import { QuestionsProgressContextProvider } from './Store/QuestionsProgressContext';
import DonutChart from './Components/DonutChart/DonutChart.jsx';
import Intro from './Pages/Intro/Intro.jsx';
import FirstForm from './Pages/FirstForm/FirstForm.jsx';
import Charts from './Pages/Chart/Chart.jsx';
import AssessmentAdditionalV3 from './Pages/AssessmentAdditionalV3/AssessmentAdditionalV3.jsx';
import Outro from './Pages/Outro/Outro.jsx';
import ContentBlocksContext from './Store/ContentBlocksContext.jsx';
import Explainer from './Pages/Explainer/Explainer.jsx';
import InviteSuccess from './Pages/InviteSuccess/InviteSuccess.jsx';
import GetStarted from './Pages/GetStarted/GetStarted.jsx';

// ReactGA.initialize('');
// ReactGA.pageview(window.location.pathname + window.location.search);

const tagManagerArgs = {
  gtmId: 'GTM-KQMN256X'
}

TagManager.initialize(tagManagerArgs)

function App() {

  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [resultPage, setResultsPage] = useState(false);
  const [contentBlocks, setContentBlocks] = useState([]);
  const [bodyBlock, setBodyBlock] = useState([]);
  const [assessmentName, setAssessmentName] = useState(window.location.pathname.split("/")?.[1]);
  const contentBlocksCtx = useContext(ContentBlocksContext);

  useEffect(() => {
  const currentPath = window.location.pathname;
  const hasVisited = localStorage.getItem('hasVisited');

  if ((currentPath === '/' || currentPath === '/start') && !hasVisited) {
    localStorage.clear();
    localStorage.setItem('hasVisited', 'true');
    console.log('localStorage cleared.');
  }
}, []);
  

  useEffect(() => {
    const url = window.location.pathname;
    if (url.split("/").includes("results")) {
      setResultsPage(true);
    } else {
      setResultsPage(false);
    }
  }, [])

  function ScrollToTop() {
    const { pathname } = useLocation()
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  
    return null;
  }

  useEffect(() => {
    getClient();
    getAssessmentContent();
    setAssessmentName(window.location.pathname.split("/")?.[1]);
    localStorage.setItem("assessmentName", assessmentName);
  }, []);
  
  console.log("window.location", window.location);

  const getAssessmentContent = () => {

    let url = window.location.href.replace("http://", "");
    url = url.replace("https://", "");
    let path = url.split("/");

    let urlId = "";
    if (path[0].includes("localhost")) {
      let devPath = path[0].split(":");
      urlId = (parseInt(devPath[1]) - 3000).toString();
    } else {
      if (url.includes("preview=")) {
        console.log("We have it");
        urlId = url.split("preview=");
        urlId = urlId[1].split("&");
        urlId = urlId[0].toString();
      }
      // else urlId = "49";
      else urlId = process.env.REACT_APP_CLIENT_ID;
    }
    
    console.log(urlId);
    // fetch(process.env.REACT_APP_API_URI + '/v1/assessment/' + urlId + '/byUrl/' + process.env.REACT_APP_URL_FIELD, {
    
    let hostname = window.location.hostname;
    if (hostname === "localhost") hostname = "mm.bleat.church";
    let assessmentURL = "https://" + hostname + "/" + assessmentName;
    console.log("assessmentURL", assessmentURL);
    const assessmentURLEncoded = encodeURIComponent(assessmentURL);
    console.log("assessmentName", assessmentName);
    
    // fetch(process.env.REACT_APP_API_URI + '/v3/assessment/' + assessmentURLEncoded + '/contentBySlug', {
		// 	method: 'GET',
		// 	mode: 'cors',
		// 	headers: { 'Content-Type': 'application/json' }
		// }).then(response => {
		// 	return response.json();
		// }).then(data => {
    //   console.log(data);
    //   contentBlocksCtx.setContentBlocks(data?.content)
		// 	if (data.status === "success") {
    //     if (path[1].includes("start")) {
    //       console.log("Are we here");
    //       setContentBlocks(data.content.filter((obj) => obj.page === "start"));
    //     }
    //     setBodyBlock(contentBlocks.filter((obj) => obj.pageArea === "background"));
    //     setIsLoading(false);
    //     console.log(contentBlocks);
    //     console.log(bodyBlock);
    //   } else {
    //     // setOpenSnackbar(true);
    //   }
		// }).catch((err) => {
    //   setIsLoading(false);
    //   console.error("Failed to get content...", err);
    // });
    
  }


  const getClient = () => {
    setIsLoading(false);
  }

  if (isLoading) {
    return <div className="container details loading"><CircularProgress style={{ color: '#00577D' }} size={60} /></div>
  }

  return (
    <div className={"App"} style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* <AssessmentProgressContextProvider> */}
      <BrowserRouter>
        <ScrollToTop />
        <AssessmentQuestionContextProvider>
          <AdditionalQuestionContextProvider>
            <PreAdditionalQuestionContextProvider>
              <QuestionsProgressContextProvider>
                <Header style={resultPage ? { backgroundColor: "#ffffff" } : { backgroundColor: "#ffffff" }} />
                <main className="main" style={{ padding: '35px 0 100px', flex: 1 }}>
                  {/* <LeftLogo/> */}
                  {/* <AssessmentProgressSections /> */}
                  <div>
                  <Routes>
                    <Route path={`/`} exact index element={<Start setName={setName} />} />
                    <Route path={`/start`} exact element={<Start setName={setName} />}></Route>
                    <Route path={`/start-individual`} exact element={<StartIndividual setName={setName} />}></Route>
                    <Route path={`/explainer/:id`} exact element={<Explainer />}></Route>
                    {/* <Route path="/before-you-start" exact element={<PreAssessment />}></Route> */}
                    <Route path={`/before-you-begin/:id`} exact element={<PreAssessment/>}></Route> 
                    <Route path={`/walkthrough/:id`} exact element={<Walkthrough />}></Route> 
                    <Route path={`/get-started/:id`} exact element={<GetStarted />}></Route> 

                    <Route path={`/assessment`} exact element={<Assessment />}></Route>
                    <Route path={`/assessment/:id/:pageId`} exact element={<AssessmentV3 />}></Route>
                    {/* <Route path="/assessment/:id/review" exact element={<Assessment />}></Route> */}
                    {/* <Route path="/assessment/:id/:pageId/review" exact element={<AssessmentV3 />}></Route> */}
                    <Route path="/pre-additional-info/:id" exact element={<PreAdditionalInfo />}></Route>
                    <Route path="/pre-additional-questions/" exact element={<PreAdditionalQuestions />}></Route>
                    {/* <Route path="/pre-additional-questions/:id" exact element={<PreAdditionalQuestions />}></Route> */}
                    <Route path="/assessment-additional/:id" exact element={<AssessmentAdditional />}></Route>
                    {/* <Route path="/assessment-additional/:id/:pageId" exact element={<AssessmentAdditional />}></Route> */}
                    <Route path="/assessment-additional/:id/:pageId" exact element={<AssessmentAdditionalV3 />}></Route>
                    <Route path="/details/:id" exact element={<Details />}></Route>
                    <Route path="/results/:id" exact element={<Results />}></Route>
                    <Route path="/invite-team/:id" exact element={<Invite />}></Route>
                    <Route path="/invite-team-thanks/:id" exact element={<InviteThankYou />}></Route>
                    <Route path="/invite-team-success/:id" exact element={<InviteSuccess />}></Route>
                    <Route path="/dashboard/:id" exact element={<Dashboard />}></Route>
                    <Route path="/chart/:id/:pageId" exact element={<DonutChart />}></Route>
                    {/* <Route path="/chart" exact element={<DonutChart/>}></Route> */}
                    <Route path="/intro/:id" exact element={<Intro />}></Route>
                    <Route path="/intro" exact element={<Intro />}></Route>
                    <Route path="/first-form/:id" exact element={<FirstForm />}></Route>
                    <Route path="/first-form" exact element={<FirstForm />}></Route>
                    <Route path="/charts/:id/:pageId" exact element={<Charts />}></Route>
                    <Route path="/outro/:id" exact element={<Outro />}></Route>
                    <Route path="/assessment-thanks/:id" exact element={<Outro />}></Route>

                  </Routes>
                  </div>
                </main>
                 <Footer /> 
              </QuestionsProgressContextProvider>
            </PreAdditionalQuestionContextProvider>
          </AdditionalQuestionContextProvider>
        </AssessmentQuestionContextProvider>
      </BrowserRouter>
      {/* </AssessmentProgressContextProvider> */}
    </div>
  );
}

export default App;
